export default {
  path: [
    // [登录注册]
    '/channel/login',

    '/feed-app/v1/h5/feed/detail',
    '/live/queryinfo',
    '/live/queryinfosimple',

    // [gift]
    '/finan/Info/myvip',
    '/finan/customgift/Info',
    '/finan/customgift/List',
    '/finan/customgift/Save',
    '/finan/gameplat/roulette/begin',
    '/finan/gameplat/roulette/create',
    '/finan/gameplat/roulette/draw',
    '/finan/gameplat/roulette/info',
    '/finan/gameplat/roulette/join',
    '/finan/gameplat/roulette/weedout',
    '/finan/goldcard/Open',
    '/finan/goldcard/Status',
    '/finan/goldegg/result',
    '/finan/goldegg/send',
    '/finan/goldegg/topLists',
    '/finan/group/info',
    '/finan/naminggift/MessagePrompt',
    '/finan/naminggift/Rank',
    '/finan/recharge/control',
    '/finan/treasurechestchain/GetRewards',
    '/finan/treasurechestchain/ReceiveRewards',
    '/finan/treasurechestchain/SetUserPopupFlag',
    '/finan/turnplate/info',
    '/finan/turnplate/play',
    '/finan/turnplate/result',
    '/finan/turnplate/shopbuy',
    '/finan/turnplate/shoplist',
    '/finan/turnplate/toplist',
    '/finan/viplevel/MsgRead',
    '/finan/viplevel/MyVipRank',
    '/giftV2/bagGiftList',
    '/giftV2/liveGiftList',
    '/giftV2/redpktTaskLists',
    '/giftV2/sendGift',
    '/giftV2H5/giftStickers',

    // [pay]
    '/com/listsV2',
    '/microService/notice/orderNotice',
    '/pay/order4Apple',
    '/pay/paymentCallback4Apple',
    '/payx/DelCardsinfo',
    '/payx/GetCardsinfo',
    '/payx/huawei/purchase',
    '/payx/ingenico/billaddrAdd',
    '/payx/ingenico/billaddrList',
    '/payx/ingenico/billaddrUpdate',
    '/payx/ingenico/pay',
    '/payx/orderInfo',
    '/payx/orderdetail',
    '/payx/orderlist',
    '/payx/stripe/pay',
    '/payx/systemMsg',
    '/payx/upOrder',
    '/payx/v1/history',
    '/seller/gear/groups',
    '/userBankExtractH5/getUserExtractList',
    '/userBankH5/bindingPayoneerAndDraw',
    '/userBankH5/getLimitDiamond',
    '/userBankH5/getMoneyByCustomDiamond',
    '/userBankH5/getUserBindingAccountList',
    '/userBankH5/bindAccount',
    '/userBankH5/withdrawal',
    '/userBankH5/bindAndDraw',

    // [礼物服务]
    '/gift_jade/v1/bag/gift',
    '/gift_jade/v1/gift/info',
    '/gift_jade/v1/gift/list',
    '/gift_jade/v1/gift/send',
    '/gift_jade/v1/giftGuide/officialSendGift',
    '/gift_jade/v1/giftGuide/report',
    '/gift_jade/v1/giftGuide/status',

    // [粉丝标签服务]
    '/fanstag/v1/fans/changeMyTag',
    '/fanstag/v1/fans/choseMyFansTag',
    '/fanstag/v1/fans/getFansInfo',
    '/fanstag/v1/fans/getMyFanTags',
    '/fanstag/v1/fans/getMyFans',
    '/fanstag/v1/fans/getRank',

    // [用户流水服务]
    '/finan_data/v1/bonus/draw',
    '/finan_data/v1/bonus/statis',
    '/finan_data/v1/diamond/consume_statistics',
    '/finan_data/v1/diamond/rank',
    '/finan_data/v1/finan/history',
    '/finan_data/v1/get/user_bag_info',
    '/finan_data/v1/liveday/rank',
    '/finan_data/v1/livetime/rank',
    '/finan_data/v1/reseller/history',
    '/finan_data/v1/reseller/statis',
    '/finan_data/v1/rules/get',
    '/finan_data/v1/vip/integral_flowing'
  ],
  reg: [
    /^\/payx\//
  ]
};
